
const getFormattedDate = (dateString: any, lang = "en") => {
    if (dateString === null || dateString === undefined || dateString.trim() === "") return "N/A";
    const date = new Date(dateString);

    // Format day with suffix
    const day = date.getDate();

    // Format month
    const months = lang === "ar" ? [
        "يناير",
        "فبراير",
        "مارس",
        "ابريل",
        "مايو",
        "يونيو",
        "يوليو",
        "اغسطس",
        "سبتمبر",
        "اكتوبر",
        "نوفمبر",
        "ديسمبر",

    ] : ["Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",];
    const month = months[date.getMonth()];

    // Format year
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
};

export default getFormattedDate;